const PROFILE_KEY = 'anchor-profile'
const GUESTS_KEY = 'anchor-guests'
const PROCEDURE_KEY = 'anchor-procedure'
const NOTICE_KEY = 'anchor-notice'
const REVIEW_KEY = 'anchor-review'
const DOWNLOAD_KEY = 'anchor-download'

export const anchorData = [
  {
    label: '活动简介',
    value: PROFILE_KEY
  }, {
    label: '分享嘉宾',
    value: GUESTS_KEY
  }, {
    label: '活动流程',
    value: PROCEDURE_KEY
  }, {
    label: '参会须知',
    value: NOTICE_KEY
  }, {
    label: '活动回顾',
    value: REVIEW_KEY
  },
  {
    label: '资料下载',
    value: DOWNLOAD_KEY
  }
]

export const anchorMap = {
  PROFILE_KEY,
  GUESTS_KEY,
  PROCEDURE_KEY,
  NOTICE_KEY,
  REVIEW_KEY,
  DOWNLOAD_KEY
}

// 文件类型
export const DATA_TYPE = new Map([
  ['image', 1],
  ['word', 5],
  ['video', 3],
  ['ppt', 4],
  ['link', 16]
])

/**
 *
 * @param {number} size -文件大小
 * @param {number} digits - 小数点后数字的个数,默认2
 * @returns
 */
export function getFileSize (size, digits = 2) {
  if (!size) { return '' }
  const num = 1024.00
  if (size < num) { return size + 'B' }
  if (size < Math.pow(num, 2)) { return (size / num).toFixed(digits) + 'K' }
  if (size < Math.pow(num, 3)) { return (size / Math.pow(num, 2)).toFixed(digits) + 'M' }
  if (size < Math.pow(num, 4)) { return (size / Math.pow(num, 3)).toFixed(digits) + 'G' }
  return (size / Math.pow(num, 4)).toFixed(2) + 'T'
}
